import { WebView } from '@zenbusiness/application-commons-webview';
import Empty from '@zenbusiness/zui/Empty';

import { useAccountExperience } from '#client/hooks/useAccountExperience';

import { AppFooterRoot, AppFooterMeta } from './AppFooter.style';
import CookiePreferences from './CookiePreferences';
import CopyrightText from './CopyrightText';
import DisclosureText from './DisclosureText';

function AppFooter() {
  const { accountExperience } = useAccountExperience();
  const { footer } = accountExperience;

  if (WebView.isWebView) {
    return <Empty />;
  }

  return (
    <AppFooterRoot>
      {footer.showDisclosure && <DisclosureText />}

      <AppFooterMeta>
        <CopyrightText />
        <CookiePreferences />
      </AppFooterMeta>
    </AppFooterRoot>
  );
}

export default AppFooter;
